import { CallableInput, CallableToggle } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import VoiceClusterName from "Components/Shared/VoiceClusterName";
import { Field, Formik } from "formik";
import { useVoiceRegion } from "Hooks/Endpoints";
import React from "react";
import { Form } from "semantic-ui-react";

const VoiceServerCreateForm = () => {
  const { createVoiceServer, saveVoiceServer, uncreateVoiceServer } =
    useVoiceRegion();
  return (
    <Formik
      validateOnChange={false}
      initialValues={createVoiceServer}
      enableReinitialize={true}
      onSubmit={(values, actions) => {
        saveVoiceServer(values);
      }}
    >
      {({ handleSubmit, errors, validateField, values }) => (
        <Form onSubmit={handleSubmit}>
          <Field name='name' label='Name' component={CallableInput} />

          <Field
            name='privateIP'
            label='Private IP'
            component={CallableInput}
          />

          <Field name='publicIP' label='Public IP' component={CallableInput} />

          <Field name='dns' label='DNS' component={CallableInput} />

          <Field
            name='teamsProxy'
            label='Teams Proxy'
            toggle
            component={CallableToggle}
          />

          <Field name='teamsDNS' label='Teams DNS' component={CallableInput} />

          <Field
            name='interconnect'
            label='Interconnect'
            toggle
            component={CallableToggle}
          />

          <Field
            name='access'
            label='Access'
            toggle
            component={CallableToggle}
          />

          <VoiceClusterName name='group' label='Group' />

          <FormSubmit
            name='Create'
            errors={errors}
            onCancel={() => uncreateVoiceServer()}
          />
        </Form>
      )}
    </Formik>
  );
};

export default VoiceServerCreateForm;
